import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangePassControlComponent } from './change-pass-control.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [ChangePassControlComponent],
  imports: [CommonModule, MatFormFieldModule, MatIconModule, MatInputModule, MatButtonModule, ReactiveFormsModule],
  exports: [ChangePassControlComponent],
})
export class ChangePassControlModule {}
